@if (currentStoryForCurrentStep$ | async; as story) {
  <dcr-dialog
    icon="shared:lightbulb"
    [attr.headline]="story.headline"
    type="custom"
    [attr.open]="(isDialogOpen$ | async) === true ? '' : undefined"
    class="[ w-full ]"
    (closed)="onDialogClosedEvent()"
    >
    <div class="[ flex gap-s justify-between center-items ][ p-xs ]">
      <dcr-outline-icon-button
        icon="shared:arrow-previous"
        [disabled]="(currentStep$ | async) === 1"
        (click)="previousStep()"
      ></dcr-outline-icon-button>
      <!-- Main Content for the dcr-dialog -->
      <div class="[ stack stack-space-m center-items ]">
        <div class="[ transform scale-125 ]">
          @switch (story.component) {
            <!-- Circular score component -->
            @case (GuideStoryComponent.CIRCULAR_SCORE) {
              @if (story.hasAnimation) {
                <dcr-circular-score
                  has-label
                  [value]="(currentTeacherAnimationProgress$ | async) || 0"
                ></dcr-circular-score>
              } @else {
                <dcr-circular-score
                  [attr.has-label]="story.isIndeterminate ? undefined : ''"
                  [value]="story.isIndeterminate ? 0 : story.fixedComponentValue"
                  [attr.indeterminate]="story.isIndeterminate ? '' : undefined"
                ></dcr-circular-score>
              }
              <!-- Animated Circular score component -->
              <!-- Static Circular score component -->
            }
            <!-- Ability meter component -->
            @case (GuideStoryComponent.SCORE) {
              @if (story.hasAnimation) {
                <campus-score
                  [result]="{ score: (currentTeacherAnimationProgress$ | async) || 0, status: 'completed' }"
                ></campus-score>
              } @else {
                <campus-score [result]="{ score: story.fixedComponentValue, status: 'completed' }"></campus-score>
              }
              <!-- Animated Score component -->
              <!-- Static Score component -->
            }
            @default {
              <!-- For Kabas -->
              @if (platform === 'kabas' && story.kabasComponent) {
                @if (story.hasAnimation) {
                  @if (currentKabasStudentAnimationProgress$ | async; as studentAnimation) {
                    <dcr-ability-meter
                      [attr.master-value]="studentAnimation.mode === LoopMode.MASTER ? studentAnimation.value : 100"
                      [attr.expert-value]="studentAnimation.mode === LoopMode.EXPERT ? studentAnimation.value : 0"
                    ></dcr-ability-meter>
                  }
                } @else {
                  <dcr-ability-meter [attr.master-value]="story.fixedComponentValue"></dcr-ability-meter>
                }
                <!-- Animated Ability Meter component -->
                <!-- Static Ability Meter component -->
              }
              <!-- For Polpo -->
              @if (platform === 'polpo' && story.polpoComponent) {
                @if (story.hasAnimation) {
                  <dcr-circular-score [value]="(currentPolpoStudentAnimationProgress$ | async) || 0"></dcr-circular-score>
                } @else {
                  <dcr-circular-score
                    [value]="story.isIndeterminate ? 0 : story.fixedComponentValue"
                    [attr.indeterminate]="story.isIndeterminate ? '' : undefined"
                  ></dcr-circular-score>
                }
                <!-- Animated Circular score component -->
                <!-- Static Circular score component -->
              }
            }
          }
        </div>
        <p class="[ body-large ]">{{ story.subHeadline }}</p>
        @if (story.description) {
          <div class="[ body-small ]" [innerHTML]="story.description | safeHtml"></div>
        }
        @if (platform === 'kabas' && story.kabasDescription) {
          <div
            class="[ body-small ]"
            [innerHTML]="story.kabasDescription | safeHtml"
          ></div>
        }
        @if (platform === 'polpo' && story.polpoDescription) {
          <div
            class="[ body-small ]"
            [innerHTML]="story.polpoDescription | safeHtml"
          ></div>
        }
      </div>
      <dcr-outline-icon-button
        icon="shared:arrow-next"
        [disabled]="(currentStep$ | async) === totalStorySteps"
        (click)="nextStep()"
      ></dcr-outline-icon-button>
    </div>
    <div slot="actions" class="[ flex flex-wrap gap-m ]">
      <dcr-checkbox
        label="Niet meer tonen"
        [value]="rememberHide"
        (change)="onRememberHideChangeEvent($event)"
      ></dcr-checkbox>
      <dcr-filled-button label="Ik begrijp het!" (click)="onAcknowledgeClickEvent()"></dcr-filled-button>
    </div>
  </dcr-dialog>
}
